/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ hour: NonNullable<unknown> }} Station_Work_Speech_Time_HourInputs */

const vi_station_work_speech_time_hour = /** @type {(inputs: Station_Work_Speech_Time_HourInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`${i?.hour} giờ`)
};

/**

* @param {Station_Work_Speech_Time_HourInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const station_work_speech_time_hour = /** @type {((inputs: Station_Work_Speech_Time_HourInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Station_Work_Speech_Time_HourInputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_station_work_speech_time_hour(inputs)
});